import React, { useState, useEffect, useRef } from "react";

import * as S from "./styles";
import { Cam } from "components/shared";

interface Props {
  stop?: boolean;
}

export const Slide3: React.FC<Props> = ({ stop }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [activeVideo, setActiveVideo] = useState<boolean>(false);
  useEffect(() => {
    if (videoRef.current) {
      if (stop) {
        setActiveVideo(false);
        return videoRef.current.load();
      }
      if (activeVideo) {
        videoRef.current.play();
      } else {
        videoRef.current.load();
      }
    }
  }, [activeVideo, stop]);

  const animeZoom = {
    scaling: {
      scale: [1, 1.3, 1],
      transition: { ease: "easeInOut", duration: 40, repeat: Infinity },
    },
  };

  return (
    <S.Container>
      <S.Text>
        Vestido, Teodora Oshima, R$ 1.460. Brinco, R$ 1.490, e anel, R$ 1.600,
        ambos Brennheisen.
      </S.Text>
      <S.PhotoWrapper>
        <S.Photo />
        <S.ButtonVideo onClick={() => setActiveVideo(!activeVideo)}>
          <S.IconPlay />
          Video
        </S.ButtonVideo>
        <S.Overlay active={activeVideo}>
          <S.Video active={activeVideo}>
            <S.ButtonClose onClick={() => setActiveVideo(false)}>
              <S.IconClose />
            </S.ButtonClose>
            <Cam />
            <video
              ref={videoRef}
              muted={!activeVideo}
              autoPlay={activeVideo}
              playsInline
            >
              <source
                src="https://player.vimeo.com/external/538839073.hd.mp4?s=189bc1c9bd443469a12804d2e2e49fd45f3169ad&profile_id=175&download=1"
                type="video/mp4"
              />
            </video>
          </S.Video>
        </S.Overlay>
      </S.PhotoWrapper>
    </S.Container>
  );
};
